"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ico_close_png_1 = __importDefault(require("../../../../assets/img/ico-close.png"));
const bg_wid_gradient_png_1 = __importDefault(require("../../../../assets/img/bg_wid_gradient.png"));
const ico_error_png_1 = __importDefault(require("../../../../assets/img/ico-error.png"));
const styles_1 = require("@mui/styles");
const familyFontConst = '"Open Sans", Helvetica,Arial,sans-serif';
exports.default = (0, styles_1.makeStyles)(() => ({
    dialog: {
        borderRadius: '5px',
        borderWidth: '0px',
        color: '#2f3c54',
        marginTop: '-160px',
        fontFamily: familyFontConst,
        background: `url(${bg_wid_gradient_png_1.default}) repeat-x left bottom #fff`,
        overflow: 'hidden'
    },
    DialogContent: {
        borderWidth: 0,
        width: '313px',
        height: '112px',
        overflow: 'hidden',
        position: 'relative',
        marginTop: '-11px'
    },
    WrapIcon: {
        position: 'relative',
        background: `url(${ico_error_png_1.default}) no-repeat`,
        width: 24,
        height: 24,
        display: 'block',
        backgroundSize: 'contain',
        marginTop: '9px',
        marginLeft: '-12px'
    },
    ListItem: {
        marginTop: '-24px'
    },
    typography: {
        'margin-left': '-5px',
        'word-break': 'break-all',
        color: '#2f3c54',
        fontWeight: 600,
        fontFamily: familyFontConst,
        fontSize: '12px',
        width: '252px'
    },
    Error2FATitle: {
        color: '#2f3c54',
        fontWeight: 'bold',
        margin: '25px 100px',
        padding: '24px 0 10px',
        fontSize: '103%',
        marginTop: '15px',
        marginLeft: '19px',
        fontFamily: familyFontConst,
        fontStyle: 'normal'
    },
    IconClose: {
        position: 'absolute',
        background: `url(${ico_close_png_1.default}) no-repeat`,
        backgroundSize: 'contain',
        width: 16,
        height: 16,
        display: 'block',
        top: '24px',
        right: '24px',
        cursor: 'pointer',
        zIndex: 1103
    },
    ConfirmButton: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        paddingTop: '10px',
        margin: '10px 10px 0'
    },
    lostOrChanged_Title: {
        margin: '0px',
        marginLeft: '10px',
        marginRight: '10px',
        fontFamily: '"Open Sans",Helvetica,Arial,sans-serif',
        fontSize: '17.58px',
        fontWeight: 700,
        color: '#2f3c54',
        paddingTop: '16px',
        paddingBottom: '10px'
    },
    lostOrChanged_Content: {
        fontFamily: '"Open Sans",Helvetica,Arial,sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        color: '#2f3c54',
        lineHeight: '14.772px',
        paddingTop: '12px',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingBottom: '4px'
    },
    OK: {
        boxSizing: 'border-box',
        background: 'linear-gradient(180deg, #606060 0, #505050 100%)',
        border: '1px solid #595959',
        borderRadius: '5px',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '9px 12px',
        color: '#FFF',
        display: 'block',
        float: 'left',
        fontSize: '13px',
        height: 'auto',
        lineHeight: 'normal',
        margin: 0,
        minWidth: '115px',
        outline: 0,
        position: 'relative',
        marginLeft: '109px',
        marginTop: '10px',
        textTransform: 'none',
        textShadow: 'none',
        fontFamily: familyFontConst,
        '&:hover': {
            background: 'linear-gradient(180deg, #606060 0, #505050 100%)'
        },
        '&:focus': {
            border: '1px solid #595959 !important',
            boxShadow: 'inset #e6e6e6 0 0 4px 0'
        }
    }
}));
